(function () {
  const originalInsertAdjacentHTML = Element.prototype.insertAdjacentHTML;
  Element.prototype.insertAdjacentHTML = function (position, text) {
    try {
      if (typeof text === 'string' && text.includes('variant-card-tag--container')) {
        const host = this; // expected to be the inner div of the variant li
        if (host && host.querySelector) {
          // Extract savings text like -12,34 € from provided HTML
          const match = text.match(/>-([^<]+) €</);
          const savingsText = match ? `-${match[1]} €` : null;
          // Ensure single container exists
          let container = host.querySelector('.variant-card-tag--container');
          if (!container) {
            container = document.createElement('div');
            container.className = 'qlf-flex qlf-items-center variant-card-tag--container';
            host.appendChild(container);
          }
          // Merge any additional containers into the first
          const containers = host.querySelectorAll('.variant-card-tag--container');
          containers.forEach((c, idx) => {
            if (idx > 0) {
              while (c.firstChild) {
                container.appendChild(c.firstChild);
              }
              c.remove();
            }
          });
          if (savingsText) {
            // Update or create the savings tag
            let tag = container.querySelector('.variant-card-tag[data-type="savings"]');
            if (!tag) {
              tag = document.createElement('div');
              tag.className = 'variant-card-tag qlf-truncate';
              tag.setAttribute('data-type', 'savings');
              container.appendChild(tag);
            }
            tag.style.backgroundColor = '#279A4B';
            tag.textContent = savingsText;
          }
          return; // Prevent original insertion of duplicate container HTML
        }
      }
    } catch (e) {
      // Fail-safe: if anything goes wrong, fall back to original method
    }
    return originalInsertAdjacentHTML.call(this, position, text);
  };
})();
/**
 * Utility function to dispatch custom events
 * @param {string} eventName - The name of the custom event
 * @param {object} detail - The detail object to pass with the event
 */
function dispatchCustomEvent(eventName, detail = {}) {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    cancelable: true,
    detail: detail
  });
  document.dispatchEvent(event);
}

function createThemeScrollLock() {
  const activeClass = 'theme-scroll-lock';
  const locks = new Map();
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const shouldLock = () => {
    for (const options of locks.values()) {
      if (!options.mobileOnly || mobileQuery.matches) {
        return true;
      }
    }

    return false;
  };

  const apply = () => {
    document.body.classList.toggle(activeClass, shouldLock());
  };

  const handleMediaQueryChange = () => {
    apply();
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleMediaQueryChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleMediaQueryChange);
  }

  return {
    lock(key, options = {}) {
      if (!key) {
        return;
      }

      locks.set(key, {
        mobileOnly: options.mobileOnly === true
      });
      apply();
    },
    unlock(key) {
      if (!key) {
        return;
      }

      locks.delete(key);
      apply();
    },
    sync() {
      apply();
    },
    isLocked(key) {
      return locks.has(key);
    }
  };
}

window.theme = window.theme || {};
window.theme.scrollLock = window.theme.scrollLock || createThemeScrollLock();

if (!customElements.get('variant-selects')) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      this.lastSelectedFlavor = null;

      this.addClickHandler();
      this.initInfoTable();
      this.rebuildSubscriptionElement();
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.syncDropdownsAfterRender();
      this.setDisabled();
      this.setImageSet();

      if (this.currentVariant) {
        // Skip updateMedia on initial load if the slider already shows the correct variant's slide
        const featuredMediaId =
          this.currentVariant.featured_media && this.currentVariant.featured_media.id;
        const correctSlideId = featuredMediaId
          ? `Slide-${this.dataset.section}-${featuredMediaId}`
          : null;
        const initialSelectedSlide =
          this.productSlider &&
          this.productSlider.querySelector('.product-images__slide.is-initial-selected');
        const alreadyCorrect =
          correctSlideId && initialSelectedSlide && initialSelectedSlide.id === correctSlideId;

        if (!alreadyCorrect) {
          // Ensure the slider is ready before updating media
          if (this.productSlider && this.productSlider.flkty) {
            this.updateMedia();
          } else {
            // If not ready, wait a bit
            setTimeout(() => {
              if (this.currentVariant && this.productSlider && this.productSlider.flkty) {
                this.updateMedia();
              }
            }, 10);
          }
        }
      }
    }

    getDropdownLabel(element) {
      if (!element) {
        return '';
      }

      if (element.dataset?.optionLabel) {
        return element.dataset.optionLabel.trim();
      }

      const labelElement = element.querySelector(
        '.qlf-select-variant-list-data, .qlf-select-variant-data'
      );

      return labelElement ? labelElement.textContent.trim() : '';
    }

    setDropdownButtonImage(button, imageUrl = '', imageAlt = '') {
      const image = button?.querySelector('.qlf-select-variant-image');
      if (!image) {
        return;
      }

      if (imageUrl) {
        image.src = imageUrl;
        image.alt = imageAlt || '';
        image.hidden = false;
        return;
      }

      image.removeAttribute('src');
      image.alt = '';
      image.hidden = true;
    }

    syncDropdownButtonFromItem(button, item) {
      if (!button || !item) {
        return;
      }

      item
        .closest('.qlf-select-variant-list')
        .querySelectorAll('li')
        .forEach((option) => {
          const isSelected = option === item;
          option.setAttribute('aria-selected', String(isSelected));
          option.classList.toggle('qlf-selected', isSelected);
          option.classList.remove('qlf-bg-gray-200');
          const optionLabel = option.querySelector('.qlf-select-variant-list-data');
          if (optionLabel) {
            optionLabel.classList.toggle('qlf-font-bold', isSelected);
            optionLabel.classList.toggle('qlf-font-normal', !isSelected);
          }
        });

      const label = this.getDropdownLabel(item);
      const dataSpan = button.querySelector('.qlf-select-variant-data');

      if (dataSpan) {
        dataSpan.textContent = label;
      }

      if (item.dataset.optionValueId) {
        button.dataset.optionValueId = item.dataset.optionValueId;
      }

      this.setDropdownButtonImage(
        button,
        item.dataset.optionImageUrl || '',
        item.dataset.optionImageAlt || label
      );
    }

    syncDropdownButtonFromValue(fieldset, label) {
      const button = fieldset?.querySelector('button.qlf-select-variant');
      if (!button) {
        return;
      }

      const normalizedLabel = (label || '').trim();
      const matchingItem = Array.from(
        fieldset.querySelectorAll('.qlf-select-variant-list li')
      ).find((item) => this.getDropdownLabel(item) === normalizedLabel);

      if (matchingItem) {
        this.syncDropdownButtonFromItem(button, matchingItem);
        return;
      }

      const dataSpan = button.querySelector('.qlf-select-variant-data');
      if (dataSpan) {
        dataSpan.textContent = normalizedLabel;
      }

      this.setDropdownButtonImage(button);
    }

    addClickHandler() {
      const variantSelects = this;
      let fieldsets = document.querySelectorAll('variant-selects fieldset');

      for (let i = 0; i < fieldsets.length; i++) {
        fieldsets[i]
          .querySelectorAll('.qlf-select-variant-list li:not(.bound)')
          .forEach((item) => {
            item.classList.add('bound');
            item.addEventListener('click', function (e) {
              e.preventDefault();

              // Remove previous selection
              this.parentElement.querySelectorAll('li').forEach((li) => {
                li.classList.remove('qlf-selected');
                li.removeAttribute('aria-selected');
              });

              // Add selection to current item
              this.classList.add('qlf-selected');
              this.setAttribute('aria-selected', 'true');

              let button = this.parentElement.parentElement.querySelector(
                'button.qlf-select-variant'
              );
              button.dataset.optionValueId = this.dataset.optionValueId;
              variantSelects.syncDropdownButtonFromItem(button, this);

              let event = new Event('change', { bubbles: true });
              this.dispatchEvent(event);

              let isVisible = this.parentElement.parentElement
                .querySelector('.qlf-select-variant-list')
                .classList.toggle('visible');
              button.setAttribute('aria-expanded', isVisible);
            });
          });
      }

      document.querySelectorAll('button.qlf-select-variant:not(.bound)').forEach((button) => {
        button.classList.add('bound');
        button.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            let list = this.nextElementSibling;
            let isVisible = list.classList.contains('visible');

            if (!isVisible) {
              // Opening the dropdown
              list.classList.add('visible');
              this.setAttribute('aria-expanded', 'true');

              // Use requestAnimationFrame to ensure the list is rendered before scrolling
              requestAnimationFrame(() => {
                let selectedItem = list.querySelector('li.qlf-selected, li[aria-selected="true"]');
                if (selectedItem) {
                  // Calculate position to center the selected item
                  let listHeight = list.clientHeight;
                  let itemOffset = selectedItem.offsetTop;
                  let itemHeight = selectedItem.offsetHeight;
                  let scrollPosition = itemOffset - listHeight / 2 + itemHeight / 2;

                  list.scrollTop = Math.max(0, scrollPosition);
                }
              });
            } else {
              // Closing the dropdown
              list.classList.remove('visible');
              this.setAttribute('aria-expanded', 'false');
            }
          },
          { passive: false }
        );
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.qlf-select-variant')) {
          document.querySelectorAll('.qlf-select-variant-list').forEach((list) => {
            list.classList.remove('visible');
            let button = list.parentElement.querySelector('.qlf-select-variant');
            if (button) {
              button.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    }
    rebuildSubscriptionElement() {
      // const subscriptionElements = document.querySelectorAll('section.shopify_subscriptions_app_block:not(.proc)');
      const subscriptionElements = null;

      if (subscriptionElements) {
        document
          .querySelector(
            '.shopify_subscriptions_app_container .shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper'
          )
          .remove();

        subscriptionElements.forEach((element) => {
          const label = element.querySelector(
            '.shopify_subscriptions_app_block_label .shopify_subscriptions_app_block_label_children li label'
          );
          const optionText = element.querySelector(
            '.shopify_subscriptions_app_block_label .shopify_subscriptions_purchase_option_wrapper label'
          ).innerHTML;
          element
            .querySelector(
              '.shopify_subscriptions_app_block_label .shopify_subscriptions_purchase_option_wrapper'
            )
            .remove();

          const price = element.querySelector(
            '.shopify_subscriptions_app_block_label_children label input'
          ).dataset.variantPrice;
          const compareAtPrice = element.querySelector(
            '.shopify_subscriptions_app_block_label_children label input'
          ).dataset.variantCompareAtPrice;

          const formattedPrice = price.replace(',', '.').replace(' €', '');
          const formattedCompareAtPrice = compareAtPrice.replace(',', '.').replace(' €', '');

          let savingsInPercent =
            ((formattedCompareAtPrice - formattedPrice) / formattedCompareAtPrice) * 100;
          savingsInPercent = savingsInPercent.toFixed(2);

          // Get all child nodes
          const nodes = Array.from(label.childNodes);
          const priceElement = `<div>Spare ${savingsInPercent}%</div><div><span style="text-decoration: line-through;">${compareAtPrice}</span><span>${price}</span></div>`;

          // Find and replace the text node
          nodes.forEach((node) => {
            if (
              node.nodeType === Node.TEXT_NODE &&
              node.textContent.includes('Jeden Monat liefern')
            ) {
              node.textContent = optionText;
            }
          });

          element
            .querySelector('.shopify_subscriptions_app_block_label_children label')
            .insertAdjacentHTML('beforeend', priceElement);

          const subHeadline = document.querySelector('.qlf-sub-text-1 .headline').innerHTML;
          element
            .querySelector('.shopify_subscriptions_fieldset')
            .insertAdjacentHTML('afterbegin', subHeadline);

          const subText = document.querySelector('.qlf-sub-text-1 .description').innerHTML;
          element
            .querySelector('.shopify_subscriptions_app_block_label_children label')
            .insertAdjacentHTML('afterend', subText);

          element.classList.add('proc');

          //click event für selection / override
          const radio = element.querySelector(
            'input[type="radio"][data-radio-type="selling_plan"]'
          );

          if (radio) {
            radio.addEventListener('click', function (e) {
              if (this.dataset.clicked === 'true') {
                this.checked = false;
                this.dataset.clicked = 'false';
                this.dispatchEvent(new Event('change', { bubbles: true }));
              } else {
                this.dataset.clicked = 'true';
              }
            });
          }
        });
      }
    }
    initInfoTable() {
      const tables = document.querySelectorAll('.nutritional-table');

      tables.forEach((table) => {
        if (table.dataset.infoTableInit === 'true') return;
        table.dataset.infoTableInit = 'true';

        let currentColumn = 1;
        const rows = table.querySelectorAll('tr');
        if (rows.length === 0) return;
        const totalColumns = rows[0].querySelectorAll('th').length;

        // Find truly static columns vs paired columns
        const firstRowCells = rows[0].querySelectorAll('th');
        const staticColumnIndices = [];
        const pairedColumnIndices = [];

        firstRowCells.forEach((th, index) => {
          if (th.classList.contains('table-cell')) {
            // Check if this is a flavor-specific %NRV column (at the end, multiple)
            if (index > 10 && th.textContent.includes('%NRV')) {
              pairedColumnIndices.push(index);
            } else {
              // Truly static column (always visible)
              staticColumnIndices.push(index);
            }
          }
        });

        // Calculate scrollable columns (excluding static and paired)
        const normalColumnCount =
          totalColumns - staticColumnIndices.length - pairedColumnIndices.length;

        // Helper function to get the paired column index
        const getPairedColumn = (column) => {
          if (pairedColumnIndices.length === 0) return null;

          // Map scrollable columns to paired columns
          // Columns 1-5 map to paired 0-4, columns 6-10 map to paired 0-4
          const scrollableIndex = column - 1;
          const pairedIndex = scrollableIndex % pairedColumnIndices.length;
          return pairedColumnIndices[pairedIndex];
        };

        const updateTable = (column) => {
          const pairedColumn = getPairedColumn(column);

          rows.forEach((row) => {
            const cells = row.querySelectorAll('th, td');
            cells.forEach((cell, index) => {
              // Show: static columns, current column, and paired column (if exists)
              if (
                staticColumnIndices.includes(index) ||
                index === column ||
                index === pairedColumn
              ) {
                cell.style.setProperty('display', '', 'important');
              } else {
                cell.style.setProperty('display', 'none', 'important');
              }
            });
          });
        };

        const triggerAnimation = () => {
          const slidingCells = table.querySelectorAll('.table-slide');
          slidingCells.forEach((cell) => {
            cell.classList.add('animate-slideaway');
          });
          setTimeout(() => {
            slidingCells.forEach((cell) => {
              cell.classList.remove('animate-slideaway');
            });
          }, 300);
        };

        updateTable(currentColumn);

        const prevButtons = table.querySelectorAll('.prev');
        const nextButtons = table.querySelectorAll('.next');

        if (normalColumnCount > 1) {
          prevButtons.forEach((prevButton) => {
            prevButton.addEventListener('click', () => {
              do {
                currentColumn =
                  currentColumn > 1
                    ? currentColumn - 1
                    : totalColumns - pairedColumnIndices.length - 1;
              } while (
                staticColumnIndices.includes(currentColumn) ||
                pairedColumnIndices.includes(currentColumn) ||
                currentColumn === 0
              );
              updateTable(currentColumn);
              triggerAnimation();
            });
          });

          nextButtons.forEach((nextButton) => {
            nextButton.addEventListener('click', () => {
              do {
                currentColumn =
                  currentColumn < totalColumns - pairedColumnIndices.length - 1
                    ? currentColumn + 1
                    : 1;
              } while (
                staticColumnIndices.includes(currentColumn) ||
                pairedColumnIndices.includes(currentColumn) ||
                currentColumn === 0
              );
              updateTable(currentColumn);
              triggerAnimation();
            });
          });
        } else {
          prevButtons.forEach((button) => (button.style.display = 'none'));
          nextButtons.forEach((button) => (button.style.display = 'none'));
        }
      });
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      const radios = document.querySelectorAll('.variations .qlf-radio-circle');

      radios.forEach(function (radio) {
        radio.classList.remove('active');
      });

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        try {
          this.updateMedia();
        } catch (error) {
          console.error('Variant media update failed', error);
        }
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();

        setTimeout(() => {
          this.syncDropdownsAfterRender();
        }, 100);

        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    syncDropdownsAfterRender() {
      if (!this.currentVariant) return;

      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      // Gehe durch alle Optionen der aktuellen Variante
      this.currentVariant.options.forEach((optionValue, index) => {
        if (fieldsets[index]) {
          this.syncDropdownButtonFromValue(fieldsets[index], optionValue);
        }
      });

      // Aktualisiere this.options
      this.updateOptions();
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('button.qlf-select-variant .qlf-select-variant-data')) {
          this.options.push(
            fieldset
              .querySelector('button.qlf-select-variant .qlf-select-variant-data')
              .textContent.trim()
          );
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }

    updateMasterId() {
      const variantData = this.getVariantData();

      switch (true) {
        default:
          this.currentVariant = variantData.find((variant) => {
            return !variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(false);
          });

          break;
        case this.options[0] == 'Probierbox':
          this.currentVariant = variantData.find((variant) => {
            return variant.options[0] === 'Probierbox';
          });
          break;

        case this.options[0] == '12er Pack' && this.options[1] == 'Probierbox':
          // WICHTIG: Setze currentVariant zurück
          this.currentVariant = null;

          // Versuche zuerst den zuletzt gewählten Geschmack zu verwenden (AUCH wenn ausverkauft)
          if (this.lastSelectedFlavor) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === '12er Pack' && variant.options[1] === this.lastSelectedFlavor
              );
            });
          }

          // Fallback: Finde die erste VERFÜGBARE Variante (nur wenn kein lastSelectedFlavor gefunden wurde)
          if (!this.currentVariant) {
            const matchingVariants = variantData.filter((variant) => {
              const matches =
                variant.options[0] === '12er Pack' &&
                variant.options[1] &&
                variant.options[1] !== 'Probierbox' &&
                variant.available; // ← NUR im Fallback prüfen wir available!
              return matches;
            });

            this.currentVariant = matchingVariants[0];
          }

          // Aktualisiere die Dropdown-Anzeige für option2 (Geschmack) SOFORT
          if (this.currentVariant) {
            this.updateDropdownDisplay(1, this.currentVariant.options[1]);
          }
          break;
        case this.options[0] == '15 Sticks' && this.options[1] == 'Probierbox':
          // WICHTIG: Setze currentVariant zurück
          this.currentVariant = null;

          // Versuche zuerst den zuletzt gewählten Geschmack zu verwenden (AUCH wenn ausverkauft)
          if (this.lastSelectedFlavor) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === '15 Sticks' && variant.options[1] === this.lastSelectedFlavor
              );
              // ← KEIN && variant.available hier!
            });
          }

          // Fallback: Finde die erste VERFÜGBARE Variante (nur wenn kein lastSelectedFlavor gefunden wurde)
          if (!this.currentVariant) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === '15 Sticks' &&
                variant.options[1] &&
                variant.options[1] !== 'Probierbox' &&
                variant.available
              ); // ← NUR im Fallback prüfen wir available!
            });
          }

          // Aktualisiere die Dropdown-Anzeige für option2 (Geschmack) SOFORT
          if (this.currentVariant) {
            this.updateDropdownDisplay(1, this.currentVariant.options[1]);
          }

          break;

          // WICHTIG: Setze currentVariant zurück
          this.currentVariant = null;

          // Versuche zuerst den zuletzt gewählten Geschmack zu verwenden
          if (this.lastSelectedFlavor) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === '15 Sticks' &&
                variant.options[1] === this.lastSelectedFlavor &&
                variant.available
              );
            });
          }

          // Fallback: Finde die erste VERFÜGBARE Variante mit 15 Sticks und einem echten Geschmack (nicht "Probierbox")
          if (!this.currentVariant) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === '15 Sticks' &&
                variant.options[1] &&
                variant.options[1] !== 'Probierbox' &&
                variant.available
              ); // ← WICHTIG: Nur verfügbare Varianten!
            });
          }

          // Aktualisiere die Dropdown-Anzeige für option2 (Geschmack) SOFORT
          if (this.currentVariant) {
            this.updateDropdownDisplay(1, this.currentVariant.options[1]);
          }
          break;

        case this.options[0] == 'Sauce' && this.options[1] == 'Probierbox':
          // WICHTIG: Setze currentVariant zurück
          this.currentVariant = null;

          // Versuche zuerst den zuletzt gewählten Geschmack zu verwenden (AUCH wenn ausverkauft)
          if (this.lastSelectedFlavor) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === 'Sauce' && variant.options[1] === this.lastSelectedFlavor
              );
            });
          }

          // Fallback: Finde die erste VERFÜGBARE Variante (nur wenn kein lastSelectedFlavor gefunden wurde)
          if (!this.currentVariant) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === 'Sauce' &&
                variant.options[1] &&
                variant.options[1] !== 'Probierbox' &&
                variant.available
              );
            });
          }

          // Aktualisiere die Dropdown-Anzeige für option2 (Geschmack) SOFORT
          if (this.currentVariant) {
            this.updateDropdownDisplay(1, this.currentVariant.options[1]);
          }

          break;
        case this.options[0] == 'Einzelriegel' && this.options[1] == 'Probierbox':
          // WICHTIG: Setze currentVariant zurück
          this.currentVariant = null;

          // Versuche zuerst den zuletzt gewählten Geschmack zu verwenden (AUCH wenn ausverkauft)
          if (this.lastSelectedFlavor) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === 'Einzelriegel' &&
                variant.options[1] === this.lastSelectedFlavor
              );
            });
          }

          // Fallback: Finde die erste VERFÜGBARE Variante (nur wenn kein lastSelectedFlavor gefunden wurde)
          if (!this.currentVariant) {
            this.currentVariant = variantData.find((variant) => {
              return (
                variant.options[0] === 'Einzelriegel' &&
                variant.options[1] &&
                variant.options[1] !== 'Probierbox' &&
                variant.available
              );
            });
          }

          // Aktualisiere die Dropdown-Anzeige für option2 (Geschmack) SOFORT
          if (this.currentVariant) {
            this.updateDropdownDisplay(1, this.currentVariant.options[1]);
          }

          break;
      }

      // Speichere den aktuell gewählten Geschmack (wenn es kein "Probierbox" ist)
      if (
        this.currentVariant &&
        this.currentVariant.options[1] &&
        this.currentVariant.options[1] !== 'Probierbox'
      ) {
        this.lastSelectedFlavor = this.currentVariant.options[1];
      }
    }

    updateDropdownDisplay(optionIndex, newValue) {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      if (fieldsets[optionIndex]) {
        this.syncDropdownButtonFromValue(fieldsets[optionIndex], newValue);

        // Aktualisiere auch this.options
        this.options[optionIndex] = newValue;
      }
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          const fs = fieldsets_array[i];
          if (!fs) {
            return; // Schutz: Kein entsprechendes Fieldset vorhanden
          }
          if (fs.querySelector('select')) {
            fs.querySelector(`select`).value = option;
          } else if (fs.querySelectorAll('input').length) {
            const input = fs.querySelector(`input[value='${option}']`);
            if (input) input.checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia(html) {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      // Bei Multipacks Bilder NICHT wechseln
      let multipack3 = document.querySelector(
        "variant-selects .qlf-multipack input[value='3 Dosen']"
      );
      let multipack5 = document.querySelector(
        "variant-selects .qlf-multipack input[value='5 Dosen']"
      );

      if ((multipack3 && multipack3.checked) || (multipack5 && multipack5.checked)) {
        return;
      }

      if (!this.productSlider) return;

      const mediaId = `Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      const thumbId = `Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      const thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      const activeMedia = this.productSlider.querySelector(`#${mediaId}`);

      if (!activeMedia) {
        const newMedia = html && html.getElementById(mediaId);
        if (!newMedia) return; // The section response supplies variants omitted on initial render.

        if (this.hideVariants) {
          this.productSlider
            .querySelectorAll('.product-images__slide-item--variant')
            .forEach((slide) => slide.remove());
          if (thumbnails) {
            thumbnails
              .querySelectorAll('.product-images__slide-item--variant')
              .forEach((thumbnail) => thumbnail.remove());
          }
        }

        // Insert into Flickity's cell container so reInit restores the new slide as well.
        const cells = this.productSlider.flkty
          ? this.productSlider.flkty.slider
          : this.productSlider;
        cells.prepend(newMedia);
        const newThumbnail = html.getElementById(thumbId);
        if (thumbnails && newThumbnail) thumbnails.prepend(newThumbnail);
      }

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        this.productSlider,
        thumbnails
      );
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      if (!productSlider) return;

      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (!activeMedia) {
        return;
      }

      let isMultipack = false;
      let multipack3 = document.querySelector(
        "variant-selects .qlf-multipack input[value='3 Dosen']"
      );
      let multipack5 = document.querySelector(
        "variant-selects .qlf-multipack input[value='5 Dosen']"
      );

      if (multipack3 && multipack3.checked) {
        isMultipack = true;
      } else if (multipack5 && multipack5.checked) {
        isMultipack = true;
      }

      // Filtere die Medien immer, sobald hideVariants aktiv ist – auch bei Multipack-Optionen
      if (flkty && this.hideVariants) {
        const initialSelected = productSlider.querySelector(
          '.product-images__slide.is-initial-selected'
        );
        if (initialSelected) {
          initialSelected.classList.remove('is-initial-selected');
        }

        [].forEach.call(
          productSlider.querySelectorAll('.product-images__slide-item--variant'),
          function (el) {
            el.classList.remove('is-active');
            el.style.display = '';
          }
        );

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');
        activeMedia.style.display = '';

        if (activeMedia.parentNode && activeMedia.parentNode.firstChild !== activeMedia) {
          activeMedia.parentNode.insertBefore(activeMedia, activeMedia.parentNode.firstChild);
        }

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          // Check if activeThumb exists before proceeding
          if (activeThumb) {
            const thumbnailInitialSelected = thumbnails.querySelector(
              '.product-thumbnail.is-initial-selected'
            );
            if (thumbnailInitialSelected) {
              thumbnailInitialSelected.classList.remove('is-initial-selected');
            }

            [].forEach.call(
              thumbnails.querySelectorAll('.product-images__slide-item--variant'),
              function (el) {
                el.classList.remove('is-active');
                el.style.display = '';
              }
            );

            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
            activeThumb.style.display = '';

            if (activeThumb.parentNode && activeThumb.parentNode.firstChild !== activeThumb) {
              activeThumb.parentNode.insertBefore(activeThumb, activeThumb.parentNode.firstChild);
            }
          }
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');

      if (!pickUpAvailability) return;

      if (!customElements.get('pickup-availability')) {
        if (!this.pickupAvailabilityReady) {
          this.pickupAvailabilityReady = customElements.whenDefined('pickup-availability').then(() => {
            this.pickupAvailabilityReady = null;
            if (this.isConnected) this.updatePickupAvailability();
          });
        }
        return;
      }

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `variant-selects-${this.dataset.section}`,
        `price-${this.dataset.section}`,
        `product-image-${this.dataset.section}--quick-view`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
        `qlf-bundle-builder-${this.dataset.section}`,
        `qlf-purchase-benefits-${this.dataset.section}`,
        `qlf-product-info-table-${this.dataset.section}`,
        `qlf-laboratory-trigger-${this.dataset.section}`,
        `qlf-laboratory-loader-${this.dataset.section}`,
        `ProductAccordion-aa2836e2-5f22-4882-a7b4-51d5ba0c254a-${this.dataset.section}`,
        `price-details-${this.dataset.section}`
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      const variantId = this.currentVariant.id;
      const requestId = (this.productInfoRequestId || 0) + 1;
      this.productInfoRequestId = requestId;

      fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          if (
            !this.isConnected ||
            requestId !== this.productInfoRequestId ||
            !this.currentVariant ||
            this.currentVariant.id !== variantId
          )
            return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.updateMedia(html);

          const fetchedButton = html.querySelector('.single-add-to-cart-button');
          const isDisabledDueToMetafield =
            fetchedButton && fetchedButton.disabled && this.currentVariant.available;

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);

            if (price) price.classList.remove('visibility-hidden');
          });

          if (isDisabledDueToMetafield) {
            this.toggleAddButton(true, 'Nicht verfügbar');
          } else if (!this.currentVariant.available) {
            this.toggleAddButton(true, window.theme.variantStrings.soldOut || 'Ausverkauft');
          } else {
            this.toggleAddButton(false);
          }

          this.addClickHandler();
          this.initInfoTable();

          dispatchCustomEvent('product:variant-rendered', {
            variant: this.currentVariant,
            sectionId: this.dataset.section
          });

          if (window.moveExistingPriceContainers) {
            window.moveExistingPriceContainers();
          }
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.product-form .single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          '.product-form .single-add-to-cart-button--text'
        );

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });
      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);

      submitButtons.forEach((submitButton) => {
        // FIX: Korrekter Selector ohne verschachteltes .product-form
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton || !submitButtonText) return;

        submitButtonText.textContent = window.theme.variantStrings.unavailable || 'Nicht verfügbar';
        submitButton.classList.add('sold-out');
      });

      if (price) price.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        let selected_options = false;

        // Check if we're in a Probierbox scenario
        const isProbierboxSelected = this.options[0] === 'Probierbox';

        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          // If no current variant, try to find a matching one
          let found_option = variant_data.find((option) => {
            return option.option1 === this.options[0];
          });

          if (found_option) {
            selected_options = [
              {
                value: this.options[0],
                index: 'option1'
              },
              {
                value: found_option.option2,
                index: 'option2'
              }
            ];
          } else if (!isProbierboxSelected) {
            // If we're not in Probierbox mode and can't find a variant, return early
            return;
          } else {
            // In Probierbox mode, use a dummy option2
            selected_options = [
              {
                value: this.options[0],
                index: 'option1'
              },
              {
                value: 'Probierbox',
                index: 'option2'
              }
            ];
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    'option[value=' + JSON.stringify(option.value) + ']'
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    'option[value=' + JSON.stringify(option.value) + ']'
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-$/, '')
        .replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`
        ),
        selected_set_thumbs = this.productWrapper.querySelectorAll(
          `.product-thumbnail[data-set-name="${this.imageSetName}"]`
        );

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach((thumb) => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach((thumb) => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Check if we're in a Probierbox scenario
      const currentOption1 = currentlySelectedValues.find(
        ({ value, index }) => index === 'option1'
      );
      const isProbierboxScenario =
        currentOption1 &&
        (currentOption1.value === 'Probierbox' || variants.some((v) => v.option1 === 'Probierbox'));

      // Reduce variant array into option availability tree
      return variants.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find((option) => option.value === variant[index]);

            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true
              };
              options[index].push(entry);
            }

            const currentOption1 = currentlySelectedValues.find(
              ({ value, index }) => index === 'option1'
            );
            const currentOption2 = currentlySelectedValues.find(
              ({ value, index }) => index === 'option2'
            );

            // Check if we're switching from/to Probierbox
            const switchingProbierbox =
              currentOption1 &&
              (currentOption1.value === 'Probierbox' || variant.option1 === 'Probierbox');

            switch (index) {
              case 'option1':
                const wasUnavailable = entry.isUnavailable;

                // Option1 inputs should be enabled if ANY variant with that option1 is available
                // when in Probierbox scenario
                if (switchingProbierbox) {
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                } else {
                  // Normal behavior: check all variants
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                }

                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                // UNLESS we're in a Probierbox scenario - then ignore option2 matching
                if (switchingProbierbox) {
                  // In Probierbox scenario: just check if variant is available, ignore option1 matching
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                } else if (currentOption1 && variant.option1 === currentOption1.value) {
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                }
                break;
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                // UNLESS we're in a Probierbox scenario - then ignore option matching
                if (switchingProbierbox) {
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                } else if (
                  currentOption1 &&
                  variant.option1 === currentOption1.value &&
                  currentOption2 &&
                  variant.option2 === currentOption2.value
                ) {
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                }
            }
          });

          return options;
        },
        { option1: [], option2: [], option3: [] }
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector(
        '.product-thumbnail-container'
      );
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container
        ? this.thumbnail_container.querySelectorAll('.product-thumbnail')
        : [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        accessibility: false
      };
    }

    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }

    restoreExternalNavigation() {
      const navContainer =
        this.parentNode && this.parentNode.querySelector('.qlf-product-slider-nav--product');

      if (!navContainer) {
        return;
      }

      const pageDots = navContainer.querySelector('.flickity-page-dots');
      if (pageDots) {
        this.appendChild(pageDots);
      }

      const arrows = navContainer.querySelectorAll('.qlf-product-slider-nav-arrows .flickity-nav');
      arrows.forEach((arrow) => {
        this.appendChild(arrow);
      });
    }

    reInit(imageSetIndex) {
      this.restoreExternalNavigation();
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();
      this.setupProductGallery();

      this.selectedIndex = this.flkty.selectedIndex;
      this.dispatchEvent(new CustomEvent('qlf:product-slider-reinit', { bubbles: true }));
    }

    setupEvents() {
      const _this = this;
      const bindArrowControl = (button, callback) => {
        if (!button || typeof callback !== 'function') {
          return;
        }

        button.addEventListener('mousedown', (event) => {
          event.preventDefault();
        });

        button.addEventListener('click', (event) => {
          event.preventDefault();
          callback();
        });

        button.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }

          event.preventDefault();
          callback();
        });
      };

      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        bindArrowControl(prev, () => this.flkty.previous());
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        bindArrowControl(next, () => this.flkty.next());
      }
      this.video_containers.forEach((container) => {
        if (container.dataset.productSliderBound) return;
        container.dataset.productSliderBound = 'true';
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        // Find the matching thumbnail via media ID instead of index correlation
        const activeSlide = this.flkty.cells[index].element;
        const mediaId = activeSlide.dataset.mediaId;
        const active_thumb =
          mediaId && this.thumbnail_container
            ? this.thumbnail_container.querySelector('#Thumb-' + mediaId)
            : null;

        this.thumbnails.forEach((item) => {
          item.classList.remove('is-initial-selected');
        });
        if (active_thumb) {
          active_thumb.classList.add('is-initial-selected');
        }

        requestAnimationFrame(() => {
          if (!active_thumb || active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(
              JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: ''
              }),
              '*'
            );
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(
              JSON.stringify({
                method: 'pause'
              }),
              '*'
            );
          }
          previous_media
            .querySelector('.product-single__media-external-video--play')
            .removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }
      });

      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(
          (element) => element.clientWidth > 0
        );
        active_thumbs.forEach((thumbnail) => {
          if (thumbnail.dataset.productSliderBound) return;
          thumbnail.dataset.productSliderBound = 'true';
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail);
          });
        });
      });
    }

    thumbnailClick(thumbnail) {
      const mediaId = thumbnail.id.replace(/^Thumb-/, '');
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.selectCell('#Slide-' + mediaId);
    }

    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }

    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }

    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }

    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll('.product-images__slide.is-active .product-single__media-image')
      );

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }

    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      this.links.forEach((link) => {
        if (link.dataset.productSliderBound) return;
        link.dataset.productSliderBound = 'true';
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      });
    }

    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions
        );
        document.body.classList.add('open-lightbox');
        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }

  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = document.getElementById(`product-form-${this.dataset.section}`);
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initInfoTable();
      }

      initInfoTable() {
        const tables = document.querySelectorAll('.nutritional-table');

        tables.forEach((table) => {
          if (table.dataset.infoTableInit === 'true') return;
          table.dataset.infoTableInit = 'true';

          let currentColumn = 1;
          const rows = table.querySelectorAll('tr');
          if (rows.length === 0) return;
          const totalColumns = rows[0].querySelectorAll('th').length;

          // Find truly static columns vs paired columns
          const firstRowCells = rows[0].querySelectorAll('th');
          const staticColumnIndices = [];
          const pairedColumnIndices = [];

          firstRowCells.forEach((th, index) => {
            if (th.classList.contains('table-cell')) {
              // Check if this is a flavor-specific %NRV column (at the end, multiple)
              if (index > 10 && th.textContent.includes('%NRV')) {
                pairedColumnIndices.push(index);
              } else {
                // Truly static column (always visible)
                staticColumnIndices.push(index);
              }
            }
          });

          // Calculate scrollable columns (excluding static and paired)
          const normalColumnCount =
            totalColumns - staticColumnIndices.length - pairedColumnIndices.length;

          // Helper function to get the paired column index
          const getPairedColumn = (column) => {
            if (pairedColumnIndices.length === 0) return null;

            // Map scrollable columns to paired columns
            // Columns 1-5 map to paired 0-4, columns 6-10 map to paired 0-4
            const scrollableIndex = column - 1;
            const pairedIndex = scrollableIndex % pairedColumnIndices.length;
            return pairedColumnIndices[pairedIndex];
          };

          const updateTable = (column) => {
            const pairedColumn = getPairedColumn(column);

            rows.forEach((row) => {
              const cells = row.querySelectorAll('th, td');
              cells.forEach((cell, index) => {
                // Show: static columns, current column, and paired column (if exists)
                if (
                  staticColumnIndices.includes(index) ||
                  index === column ||
                  index === pairedColumn
                ) {
                  cell.style.setProperty('display', '', 'important');
                } else {
                  cell.style.setProperty('display', 'none', 'important');
                }
              });
            });
          };

          const triggerAnimation = () => {
            const slidingCells = table.querySelectorAll('.table-slide');
            slidingCells.forEach((cell) => {
              cell.classList.add('animate-slideaway');
            });
            setTimeout(() => {
              slidingCells.forEach((cell) => {
                cell.classList.remove('animate-slideaway');
              });
            }, 300);
          };

          updateTable(currentColumn);

          const prevButtons = table.querySelectorAll('.prev');
          const nextButtons = table.querySelectorAll('.next');

          if (normalColumnCount > 1) {
            prevButtons.forEach((prevButton) => {
              prevButton.addEventListener('click', () => {
                do {
                  currentColumn =
                    currentColumn > 1
                      ? currentColumn - 1
                      : totalColumns - pairedColumnIndices.length - 1;
                } while (
                  staticColumnIndices.includes(currentColumn) ||
                  pairedColumnIndices.includes(currentColumn) ||
                  currentColumn === 0
                );
                updateTable(currentColumn);
                triggerAnimation();
              });
            });

            nextButtons.forEach((nextButton) => {
              nextButton.addEventListener('click', () => {
                do {
                  currentColumn =
                    currentColumn < totalColumns - pairedColumnIndices.length - 1
                      ? currentColumn + 1
                      : 1;
                } while (
                  staticColumnIndices.includes(currentColumn) ||
                  pairedColumnIndices.includes(currentColumn) ||
                  currentColumn === 0
                );
                updateTable(currentColumn);
                triggerAnimation();
              });
            });
          } else {
            prevButtons.forEach((button) => (button.style.display = 'none'));
            nextButtons.forEach((button) => (button.style.display = 'none'));
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form.reportValidity()) {
          return;
        }

        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

        // QLF Protection: Check if any button is already loading
        let isAnyButtonLoading = false;
        submitButtons.forEach((btn) => {
          if (btn.classList.contains('loading')) isAnyButtonLoading = true;
        });

        if (isAnyButtonLoading) {
          console.log('ProductForm: Submit blocked because button is already loading');
          return;
        }

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains('loading')) return;
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        });

        this.handleErrorMessage();

        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript'
          }
        };

        let formData = new FormData(this.form);

        formData.append(
          'sections',
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent('product:variant-error', {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });

            // Only apply discount code if the form's submit button has the data-discount-code attribute
            const submitButton = this.form.querySelector('.single-add-to-cart-button');
            if (submitButton && submitButton.hasAttribute('data-discount-code')) {
              const discountCode = submitButton.dataset.discountCode;
              if (discountCode && discountCode.trim() !== '') {
                fetch(`/discount/${discountCode}`, {
                  method: 'GET'
                })
                  .then((response) => {
                    if (response.ok) {
                      // console.log(`Discount code ${discountCode} applied successfully`);
                    } else {
                      console.error(`Failed to apply discount code: ${discountCode}`);
                    }
                  })
                  .catch((error) => {
                    console.error('Error applying discount code:', error);
                  });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            });
          });
      }

      getSectionsToRender() {
        return [
          {
            id: 'Cart',
            section: 'main-cart',
            selector: '.thb-cart-form'
          },
          {
            id: 'Cart-Drawer',
            section: 'cart-drawer',
            selector: '.cart-drawer'
          },
          {
            id: 'cart-drawer-toggle',
            section: 'cart-bubble',
            selector: '.thb-item-count'
          }
        ];
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          if (typeof CartDrawer !== 'undefined') {
            new CartDrawer();
          }
          if (typeof Cart !== 'undefined') {
            new Cart().renderContents(parsedState);
          }
        });

        let product_drawer = document.getElementById('Product-Drawer'),
          search_drawer = document.getElementById('Search-Drawer');

        if (search_drawer.classList.contains('active')) {
          search_drawer.classList.remove('active');
        }
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove('active');
          this.body.classList.remove('open-cc--product');
          if (document.getElementById('Cart-Drawer')) {
            this.body.classList.add('open-cc');
            document.getElementById('Cart-Drawer').classList.add('active');
          }
        } else if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
          dispatchCustomEvent('cart-drawer:open');
        }
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer
        .querySelector('.side-panel-content--inner')
        .querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }

    connectedCallback() {
      this.setupObservers();
    }

    disconnectedCallback() {}

    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.qlf-add-to-cart:not(.bound)').forEach((element) => {
    element.classList.add('bound');
    const buttonElement = element.querySelector('button');

    if (!buttonElement) {
      return;
    }

    buttonElement.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const button = e.currentTarget;
      if (button.classList.contains('loading')) {
        return;
      }

      let formData = {
        items: [
          {
            id: button.dataset.productid,
            quantity: 1
          }
        ]
      };

      button.classList.add('loading');
      element.querySelector('.loading-overlay svg').style.opacity = 1;
      element.querySelector('.single-add-to-cart-button--text').style.display = 'none';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((response) => {
          button.classList.remove('loading');
          element.querySelector('.loading-overlay svg').style.opacity = 0;
          element.querySelector('.single-add-to-cart-button--text').style.display = 'block';
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: response
            })
          );
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          if (
            button.classList.contains('single-add-to-cart-button') &&
            button.hasAttribute('data-discount-code')
          ) {
            const discountCode = button.dataset.discountCode;
            if (discountCode && discountCode.trim() !== '') {
              fetch(`/discount/${discountCode}`, {
                method: 'GET'
              })
                .then((response) => {
                  if (response.ok) {
                    // console.log(`Discount code ${discountCode} applied successfully`);
                  } else {
                    console.error(`Failed to apply discount code: ${discountCode}`);
                  }
                })
                .catch((error) => {
                  console.error('Error applying discount code:', error);
                });
            }
          }
        })
        .catch((error) => {
          button.classList.remove('loading');
          element.querySelector('.loading-overlay svg').style.opacity = 0;
          element.querySelector('.single-add-to-cart-button--text').style.display = 'block';
          console.error('Error:', error);
        });
    });
  });
});
